import { Suspense } from 'react'
import { Toaster } from 'sonner'
import { ReduxProvider } from './providers/ReduxProvider'
import { AppRouter } from '@/features/routes/AppRouter'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

function App() {
  return (
    <ReduxProvider>
      <Suspense fallback={<LoadingSpinner />}>
        <AppRouter />
      </Suspense>
      <Toaster position="top-right" richColors />
    </ReduxProvider>
  )
}

export default App
